import { Radar } from "lucide-react";
import {
  LamaMaturityHierarchyParamsSchema,
  defaultLamaMaturityHierarchyParams,
  type LamaMaturityHierarchyParams,
  type LamaMaturityHierarchyView,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaMaturityHierarchyWidget } from "./Component.js";

/**
 * LAMA Maturity Overview — the v3 Pillar → Category → Question headline over
 * the bounded baseline + latest-wave pair (2026-09-10 ADR-0027 amendment).
 * Params are `{}`-strict: which side is drawn is the host's `?view=`, applied
 * display-only. `TView` is the `lama/maturity-hierarchy@1` output plus that
 * view.
 */
export const lamaMaturityHierarchyDef: SqlWidgetDef<
  LamaMaturityHierarchyParams,
  LamaMaturityHierarchyView
> = {
  kind: "lamaMaturityHierarchy",
  label: "Maturity Overview",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 560 },
  defaultParams: defaultLamaMaturityHierarchyParams,
  Component: LamaMaturityHierarchyWidget,
  storage: "sql",
  schema: LamaMaturityHierarchyParamsSchema,
  accent: "cyan",
  icon: Radar,
  subtitle: "Baseline, responses and their comparison by pillar",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 1, width: 960, height: 560 },
  dashboard: {
    icon: Radar,
    defaultWidth: "full",
    category: "Operations",
    supportsTitleOverride: true,
  },
};

registerWidget(lamaMaturityHierarchyDef);
